import { Box, Typography } from '@mui/material'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import Button from '@/components/Button'
import Dialog from '@/components/Dialog'
import { useAppSelector } from '@/hooks/redux'
import { useGetCaseDetailsQuery } from '@/store/apiService'
import { setNewImages } from '@/store/appSlice'
import { getCaseId } from '@/utils'

import FileList from './FileList'

type FileListPopupEntity = {
  open: boolean
  onClose: () => void
  setMenuAnchorElement: any
}

interface SelectedItem {
  id: string
  type: any
}

const ProjectImageList = (props: FileListPopupEntity) => {
  const { open, onClose, setMenuAnchorElement } = props
  const [selected, setSelected] = useState<SelectedItem[]>([])
  const existingNewImages = useAppSelector((state) => state.app.newImages || [])

  const handleSelect = (id: string, checked: boolean, type: any) => {
    if (checked) {
      setSelected((prev) =>
        prev.filter((item) => !(item.id === id && item.type === type)),
      )
    } else {
      setSelected((prev: any) => [...prev, { id, type }])
    }
  }

  const handleAllSelectionClick = () => {
    if (!caseDetails?.images) return

    const allItems = caseDetails.images.map((img) => ({
      id: img.id,
      type: img.type,
    }))
    setSelected(allItems)
  }

  const caseId = getCaseId()

  const { data: caseDetails } = useGetCaseDetailsQuery(
    { caseId: caseId },
    { skip: !caseId },
  )

  const dispatch = useDispatch()

  const title = (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      width={'100%'}
    >
      <Typography fontSize={'20px'} fontWeight={500}>
        Select Images
      </Typography>
    </Box>
  )

  const content = (
    <FileList
      data={caseDetails?.images}
      selected={selected}
      handleSelect={handleSelect}
      newImages={existingNewImages}
    />
  )

  const actionButtons = (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Button
        label="SELECT ALL"
        onClick={handleAllSelectionClick}
        variant="outlined"
      />
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button label="CANCEL" onClick={onClose} variant="outlined" />
        <Button
          variant="contained"
          label="ADD"
          onClick={() => {
            if (!caseDetails?.images) return

            const selectedImages = caseDetails.images.filter((img) =>
              selected.some(
                (sel) => sel.id === img.id && sel.type === img.type,
              ),
            )

            const updatedImages = [
              ...(Array.isArray(existingNewImages) ? existingNewImages : []),
              ...selectedImages,
            ]

            dispatch(setNewImages(updatedImages))
            onClose()
            setMenuAnchorElement(null)
          }}
          sx={{
            color: '#131A20',
            borderColor: '#90CAF9',
            backgroundColor: '#90CAF9',
            '&.Mui-disabled': {
              color: '#7B7B7B',
              backgroundColor: '#434343',
            },
          }}
          disabled={selected.length === 0}
        />
      </Box>
    </Box>
  )

  return (
    <Dialog
      isOpen={open}
      onClose={onClose}
      title={title}
      content={content}
      actionButtons={actionButtons}
      maxWidth="md"
      triggerElement={undefined}
    />
  )
}

export default ProjectImageList
